import { HStack, Text } from '@chakra-ui/react';
import { WarningTriangle } from 'iconoir-react';

/** Red inline validation banner reused across the editor sections. */
export const InlineErrorBanner = ({ message }: { message: string }) => (
  <HStack
    gap="2"
    align="flex-start"
    bg="red.50"
    borderWidth="1px"
    borderColor="red.200"
    rounded="lg"
    px="14px"
    py="10px"
  >
    <Text color="fg.error" flex="none" mt="0.5">
      <WarningTriangle width={14} height={14} />
    </Text>
    <Text fontSize="12.5px" color="fg.error" lineHeight="1.4">
      {message}
    </Text>
  </HStack>
);
